var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_4157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_4157)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_4157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_4157)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.267896 16.6437H-1.36658",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.243214 17.4863H-0.02771V17.0169H0.542712V16.6323V17.4863H0.800841V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0913 16.6831C1.0913 16.7303 1.0913 17.4899 1.0913 17.4899H0.823364",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07283 16.6437H1.43835",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42151 17.5066V17.0063H1.95358V17.4898H2.49122V17.0069H2.21228",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09807 17.4863H2.82715V17.0169H3.39757V16.6323V17.4863H3.6557V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94616 16.6831C3.94616 16.7303 3.94616 17.4899 3.94616 17.4899H3.67822",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92769 16.6437H4.29321",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27637 17.5066V17.0063H4.80843V17.4898H5.34608V17.0069H5.06714",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.903 17.4863H5.63208V17.0169H6.2025V16.6323V17.4863H6.46063V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75109 16.6831C6.75109 16.7303 6.75109 17.4899 6.75109 17.4899H6.48315",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73262 16.6437H7.09814",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0813 17.5066V17.0063H7.61337V17.4898H8.15101V17.0069H7.87207",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70794 17.4863H8.43701V17.0169H9.00743V16.6323V17.4863H9.26556V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55602 16.6831C9.55602 16.7303 9.55602 17.4899 9.55602 17.4899H9.28809",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5375 16.6437H9.90308",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88623 17.5066V17.0063H10.4183V17.4898H10.9559V17.0069H10.677",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5628 17.4863H11.2919V17.0169H11.8623V16.6323V17.4863H12.1204V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 16.6831C12.4109 16.7303 12.4109 17.4899 12.4109 17.4899H12.1429",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 16.6437H12.7579",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7411 17.5066V17.0063H13.2732V17.4898H13.8108V17.0069H13.5319",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4178 17.4863H14.1469V17.0169H14.7173V16.6323V17.4863H14.9754V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2659 16.6831C15.2659 16.7303 15.2659 17.4899 15.2659 17.4899H14.9979",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2474 16.6437H15.6129",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5961 17.5066V17.0063H16.1281V17.4898H16.6658V17.0069H16.3868",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 17.4863H17.0018V17.0169H17.5723V16.6323V17.4863H17.8304V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1208 16.6831C18.1208 16.7303 18.1208 17.4899 18.1208 17.4899H17.8529",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1024 16.6437H18.4679",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.451 17.5066V17.0063H18.9831V17.4898H19.5208V17.0069H19.2418",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0777 17.4863H19.8068V17.0169H20.3772V16.6323V17.4863H20.6353V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9258 16.6831C20.9258 16.7303 20.9258 17.4899 20.9258 17.4899H20.6578",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9073 16.6437H21.2728",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.256 17.5066V17.0063H21.788V17.4898H22.3257V17.0069H22.0468",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0328 17.4863H22.7618V17.0169H23.3323V16.6323V17.4863H23.5904V16.6323",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.267896 4.95179H-1.36658",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.243214 5.79439H-0.02771V5.32498H0.542712V4.94043V5.79439H0.800841V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0913 4.99121C1.0913 5.03841 1.0913 5.79798 1.0913 5.79798H0.823364",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07283 4.95179H1.43835",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42151 5.81471V5.31445H1.95358V5.79791H2.49122V5.31499H2.21228",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09807 5.79439H2.82715V5.32498H3.39757V4.94043V5.79439H3.6557V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94616 4.99121C3.94616 5.03841 3.94616 5.79798 3.94616 5.79798H3.67822",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92769 4.95179H4.29321",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.27637 5.81471V5.31445H4.80843V5.79791H5.34608V5.31499H5.06714",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.903 5.79439H5.63208V5.32498H6.2025V4.94043V5.79439H6.46063V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75109 4.99121C6.75109 5.03841 6.75109 5.79798 6.75109 5.79798H6.48315",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73262 4.95179H7.09814",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0813 5.81471V5.31445H7.61337V5.79791H8.15101V5.31499H7.87207",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70794 5.79439H8.43701V5.32498H9.00743V4.94043V5.79439H9.26556V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55602 4.99121C9.55602 5.03841 9.55602 5.79798 9.55602 5.79798H9.28809",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5375 4.95179H9.90308",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88623 5.81471V5.31445H10.4183V5.79791H10.9559V5.31499H10.677",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5628 5.79439H11.2919V5.32498H11.8623V4.94043V5.79439H12.1204V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 4.99121C12.4109 5.03841 12.4109 5.79798 12.4109 5.79798H12.1429",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 4.95179H12.7579",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7411 5.81471V5.31445H13.2732V5.79791H13.8108V5.31499H13.5319",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4178 5.79439H14.1469V5.32498H14.7173V4.94043V5.79439H14.9754V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2659 4.99121C15.2659 5.03841 15.2659 5.79798 15.2659 5.79798H14.9979",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2474 4.95179H15.6129",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5961 5.81471V5.31445H16.1281V5.79791H16.6658V5.31499H16.3868",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 5.79439H17.0018V5.32498H17.5723V4.94043V5.79439H17.8304V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1208 4.99121C18.1208 5.03841 18.1208 5.79798 18.1208 5.79798H17.8529",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1024 4.95179H18.4679",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.451 5.81471V5.31445H18.9831V5.79791H19.5208V5.31499H19.2418",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0777 5.79439H19.8068V5.32498H20.3772V4.94043V5.79439H20.6353V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9258 4.99121C20.9258 5.03841 20.9258 5.79798 20.9258 5.79798H20.6578",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9073 4.95179H21.2728",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.256 5.81471V5.31445H21.788V5.79791H22.3257V5.31499H22.0468",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0328 5.79439H22.7618V5.32498H23.3323V4.94043V5.79439H23.5904V4.94043",
    stroke: "#F7FCFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4982 7.90625C10.4982 7.90625 10.8054 8.12188 11.1197 8.12188C11.4341 8.12188 11.7504 7.90625 11.7504 7.90625V8.19375C11.7504 8.19375 11.4051 8.40938 11.0993 8.40938C10.7935 8.40938 10.4982 8.19375 10.4982 8.19375V7.90625ZM8.23425 11.2993C8.23425 9.59541 9.98943 8.48125 9.98943 8.48125C9.98943 8.48125 8.97497 9.20595 8.97497 11.2279C8.97497 13.2499 9.5016 14.1255 9.5016 14.1255C9.5016 14.1255 8.23425 13.0032 8.23425 11.2993ZM14.1551 11.2053C14.1551 9.50138 12.4015 8.48125 12.4015 8.48125C12.4015 8.48125 13.416 9.20595 13.416 11.2279C13.416 13.2499 12.8894 14.1255 12.8894 14.1255C12.8894 14.1255 14.1551 12.9092 14.1551 11.2053ZM9.43249 11.6702C9.3656 9.96861 10.4272 8.44342 10.4272 8.44342C10.4272 8.44342 10.0408 9.14427 10.1202 11.1635C10.1475 11.8568 10.3523 12.8883 10.6103 13.4964V8.55313H11.6884V13.5393C11.9468 12.9712 12.1459 12.0027 12.1735 11.2993C12.2529 9.28013 11.885 8.44342 11.885 8.44342C11.885 8.44342 12.9467 9.96861 12.8798 11.6702C12.84 12.6836 12.2551 13.7554 11.7886 14.4565C12.0153 14.5239 12.3191 14.6061 12.7368 14.716C12.7457 14.7776 12.6527 14.7748 12.4677 14.7691C12.2635 14.7629 11.9473 14.7532 11.5328 14.823C11.3422 15.0835 11.2095 15.2379 11.2095 15.2379C11.2095 15.2379 11.1885 15.2001 11.1561 15.1478C11.1238 15.2001 11.1028 15.2379 11.1028 15.2379C11.1028 15.2379 10.9701 15.0835 10.7795 14.823C10.365 14.7532 10.0488 14.7629 9.84456 14.7691C9.65962 14.7748 9.56655 14.7776 9.57546 14.716C9.99315 14.6061 10.297 14.5239 10.5237 14.4565C10.0572 13.7554 9.47232 12.6836 9.43249 11.6702Z",
    fill: "#E31D1C"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_4157)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_4157",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrr);
export default __webpack_public_path__ + "static/media/IRR.3e7ce2a169639ed204a53d7402fbe83a.svg";
export { ForwardRef as ReactComponent };